import { render, staticRenderFns } from "./FBA.vue?vue&type=template&id=56b6af62&scoped=true&"
import script from "./FBA.vue?vue&type=script&lang=js&"
export * from "./FBA.vue?vue&type=script&lang=js&"
import style0 from "./FBA.vue?vue&type=style&index=0&id=56b6af62&prod&scoped=true&lang=css&"
import style1 from "./FBA.vue?vue&type=style&index=1&id=56b6af62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6af62",
  null
  
)

export default component.exports